import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

const StatCard = ({ title, value, icon }) => {
  return (
    <Card sx={{ display: 'flex', alignItems: 'center', p: 2, height: '100%' }}>
      <Box sx={{ mr: 2 }}>
        {icon}
      </Box>
      <Box>
        <Typography variant="h6" color="text.secondary">
          {title}
        </Typography>
        <Typography variant="h4" component="p" sx={{ fontWeight: 'bold' }}>
          {value}
        </Typography>
      </Box>
    </Card>
  );
};

export default StatCard;
